import { render, staticRenderFns } from "./CommissioningDetail.vue?vue&type=template&id=2c423906&scoped=true"
import script from "./CommissioningDetail.vue?vue&type=script&lang=js"
export * from "./CommissioningDetail.vue?vue&type=script&lang=js"
import style0 from "./CommissioningDetail.vue?vue&type=style&index=0&id=2c423906&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c423906",
  null
  
)

export default component.exports